import { useEffect } from 'react';
import axios from 'axios';
import { useAuthHeader, useAuthUser } from "../../../../Services/Auth/sessionAuth";
import Utilisateur from "../../../../Models/Utilisateur";
import { useState } from "react";
import { Button, Form, Tabs, Space, Spin, Checkbox } from 'antd';
import Table from '../../../TableResizable';
import type { TabsProps } from 'antd';
import Demand from '../../../../Models/MMontantBloquer';
import { Box, Typography } from '@mui/material';
import SweetAlert from "sweetalert2";
import InputForm from "../../../InputT";
import SearchModal from "../../../SearchModal";
import { UserOutlined, ContactsOutlined, UsergroupAddOutlined } from '@ant-design/icons';
import ParamsPicklist from "../../../../Types/ParamsPicklist"
import Tab2 from './ta1';
import SearInputG from "../../../SearchInput"
import Data from '../../../../Data/Data.json'

import React from "react";
//pour le tableau
import DataType from "../../../../Functions/Traitement/DataPeriodMbloquer";
import { ColumnGroupType, ColumnsType } from 'antd/es/table';
import { Crypter } from "../../../../Functions/Security/Crypter";
import ReformatDate from '../../../../Functions/Traitement/ReformatDate';
import formatDate from '../../../../Functions/Traitement/fomatDate';
import SearInputM from '../../../SearchModal';

import { Input, Select } from 'antd';
import { CircularProgress } from '@mui/material';
import COMPTES from '../../../../Models/Comptes';




const AddBlocage = () => {

    //column du tableau 
    const columns: ColumnsType<DataType> = [
        {
            title: 'N° CREDIT',
            dataIndex: 'REFMARQ',
        },
        {
            title: 'ID CLIENT',
            dataIndex: 'codage',
        },
        {
            title: 'NOM CLIENT',
            dataIndex: 'NUMCPT',
        },
        {
            title: 'NOM SERVICE',
            dataIndex: 'NOMCPT',
        },
        {
            title: 'Nat CREDIT',
            dataIndex: 'MONTPR',
        },
        {
            title: 'MONTANT',
            dataIndex: 'DISPON',
        },
        {
            title: 'DATE EFFET',
            dataIndex: 'DATCRE',
        },
        {
            title: 'DATE FIN',
            dataIndex: 'DATEFM',
        }
    ];



    // USER SESSION
    const [form] = Form.useForm();
    const auth = useAuthUser()
    const Perss: Utilisateur = JSON.parse(JSON.stringify(auth()))
    const [loading, setLoading] = useState(false);
    const [isSubmit, setIsSubmit] = useState(false)
    const [ajoutActve, setAjoutActif] = useState(false)
    const [donnees, setData] = useState<DataType[]>([]);
    const [sbmit, setSbmit] = useState("")
    const authHeader = useAuthHeader()
    const [LibellCode, SetLibellCode] = useState(false)

    // Trie des Comptes 
    const [Idclient, setIdclient] = useState('aba')

    let searchCompte: ParamsPicklist = { CodeAgence: Perss.codage, Table: "COMPTES", Colonne1: "NUMCPT", Colonne2: "NOMCPT", Colagence: 'AGCCPT', colfiltre: "NUMCLI", valfiltre: Idclient, Choix: 22 }


    let searchMontanLock: ParamsPicklist = { CodeAgence: Perss.codage, Table: "PROVISION", Colonne1: "REFMARQ", Colonne2: "NOMCPT", Colagence: 'codage', colfiltre: "", valfiltre: '', Choix: 22 }
    let searchCLient: ParamsPicklist = { CodeAgence: Perss.codage, Table: "CLIENT", Colonne1: "NUMCLI", Colonne2: "NOMCLI", Colagence: "CODAGE", colfiltre: "", valfiltre: '', Choix: 22 }
    let searchCsion: ParamsPicklist = { CodeAgence: '', Table: "OPERAT", Colonne1: "CODOPE", Colonne2: "LIBELL", Colagence: '101', Choix: 22 }

    //let searchVirementPerme: ParamsPicklist = { CodeAgence: Perss.codage, Table: "ORDREPERM", Colonne1: "NUMDOS", Colonne2: "LIBCPTDEB", Colagence: 'codage', colfiltre: "", valfiltre: '', Choix: 22 }


    const Getselectcli = (value: any) => {
        setIdclient(form.getFieldValue("NUMCLI"))
        //RemplirGarantie()
        //props.form.setFieldValue("IDLIMITE", '')

    }

    // usestate 
    const [Consult, setConsult] = useState(false);
    const [Ajout, setAjout] = useState(false);
    const [Modif, setModif] = useState(true);
    const [Enreg, setEnreg] = useState(true);
    const [Annul, setAnnul] = useState(true);
    const [Actualise, setActual] = useState(true);
    const [Supp, setSupprim] = useState(true);

    // handle
    function HandleConsult() {
        setConsult(true);
        setAjout(true);
        setModif(false);
        setAnnul(false);
        SetLibellCode(true)
    }

    function HandleAjout() {
        setConsult(true);
        setAjout(true);
        setEnreg(false);
        setActual(false);
        setAnnul(false);
        setAjoutActif(true)
        SetLibellCode(true)
    }

    function HandleModif() {
        setModif(true);
        setEnreg(false);
        setAjoutActif(true)
    }

    function HandleEnreg() {

        HandleAnnul();
    }

    function HandleAnnul() {
        setAjout(false);
        setConsult(false);
        setModif(true);
        setEnreg(true);
        setActual(true);
        setAnnul(true);
        setAjoutActif(false);
        form.resetFields();
        setSbmit('');
        SetLibellCode(false)
        SetCompetClients([])
        setNumcpt("")
    }

    function HandleReset() {
        form.resetFields();
        SetCompetClients([]);
        setNumcpt("");
    }

    function HandleSupp() {

    }



    // Gestion des Items 
    const items: TabsProps['items'] = [

        {
            key: '2',
            label: (
                <span id='Tab'>
                    <UserOutlined />
                    Montant Bloquer
                </span>
            ),
            children: <Tab2 form={form} />, //form={form}
        },

    ];


    //  function consult
    function consult() {


        if (form.getFieldValue("REFMARQ") == null) {
            SweetAlert.fire({ title: "Svp renseigner le numero de reference", icon: "warning" });
            HandleAnnul();
        } else {
            let data = Crypter.encrypt(form.getFieldValue("REFMARQ"));
            //alert(form.getFieldValue("REFMARQ"))
            if (data.length != 0) {
                setLoading(true)
                form.resetFields()
                let config = {
                    method: 'get',
                    maxBodyLength: Infinity,
                    url: Data.ApiUrl.ReadMontantBloquer,
                    headers: {
                        'CypherREFMARQ': data,
                        'Authorization': authHeader(),
                        'Content-Type': 'application/json'
                    },
                };

                axios.request(config)
                    .then((response) => {
                        setLoading(false);

                        if (response.data) {
                            const res = JSON.parse(Crypter.decrypt(response.data));
                            console.log(JSON.stringify(res))
                            let MontantBloquer = res.Result.Table[0]

                            if (res.StatutCode == 200) {
                                form.setFieldsValue(MontantBloquer);
                                //alert(MontantBloquer.DATEFM)
                                form.setFieldValue("DATEFM", ReformatDate(MontantBloquer.DATEFM));
                                setNumcpt(MontantBloquer.NUMCPT)
                            }
                            else {
                                SweetAlert.fire({ title: "Warning", text: res.Message, icon: "warning" })
                            }
                        }
                        setLoading(false)
                    })
                    .catch((error) => {
                        setLoading(false);
                        //console.log(error)
                        SweetAlert.fire({ title: "Error", text: error, icon: "error" })
                    });
            }
        }
    }

    // function getCompte

    function GetCompte() {
        if (form.getFieldValue("NUMCPT") == null) {
            alert(1)
        } else {
            let data = Crypter.encrypt(form.getFieldValue("NUMCPT"));
            // let IDLIMITE = form.getFieldValue("IDLIMITE")
            if (data.length != 0) {

                setLoading(true)
                //form.setFieldValue("IDLIMITE", IDLIMITE)
                let config = {
                    method: 'get',
                    maxBodyLength: Infinity,
                    url: Data.ApiUrl.GetCompte,
                    headers: {
                        'CypherNumCpte': data,
                        'Authorization': authHeader(),
                        'Content-Type': 'application/json'
                    },
                    //data: data
                };
                axios.request(config)
                    .then((response) => {
                        setLoading(false);
                        if (response.data) {
                            const res = JSON.parse(Crypter.decrypt(response.data));
                            //console.log(JSON.stringify(res))
                            let Compte = res.Result.Table[0]
                            //console.log(JSON.stringify(limite))

                            if (res.StatutCode == 200) {
                                console.log(Compte)
                                //form.setFieldsValue(limite);
                                // NivCons  MNTlimite  NUMOrdre
                                form.setFieldValue("DISPON", Compte.DISPON)
                            }
                            else {
                                SweetAlert.fire({ title: "Warning", text: res.Message, icon: "warning" })
                            }
                        }
                        setLoading(false)
                    })
                    .catch((error) => {
                        setLoading(false);
                        console.log(error)
                        SweetAlert.fire({ title: "Error Getdispon", text: error, icon: "error" })
                    });
            }
        }
    }



    // function Onfinish
    const onFinish = (values: any) => {
        console.log(values)
        var DemandMont: Demand = values
        DemandMont.codage = Perss.codage
        DemandMont.UTILIS = Perss.coduti;

        //DemandMont.NUMCPT = numcpt

        //alert (DemandMont.NUMCPT)

        if (sbmit == "add") {
            DemandMont.DATEFM = formatDate(DemandMont.DATEFM);
            DemandMont.DATCRE = formatDate(Perss.datjour);
            DemandMont.DATVAL = (DemandMont.DATEFM);

            if (form.getFieldValue("DATEFM") <= ReformatDate(Perss.datjour)) {
                SweetAlert.fire({ text: "Opération impossible: La date fin bloquage doit être supérieur à la date système ", icon: "warning" })
            } else {
                if ((form.getFieldValue("MONTPR")) > (form.getFieldValue("DISPON"))) {
                    SweetAlert.fire({ text: "Opération impossible: le disponible du compte est insuffisant pour le blocage", icon: "warning" })
                } else {
                    if ((form.getFieldValue("MONTPR")) < 0) {
                        SweetAlert.fire({ text: "Opération impossible: Le montant a bloqué doit être supérieur 0", icon: "warning" })
                    } else {

                        SweetAlert.fire({
                            title: "Création du Gel",
                            text: "Voulez-vous Créer le Gel de :" + values.lib_NUMCPT + " ?",
                            showCancelButton: true,
                            color: "green",
                            confirmButtonText: "Yes",
                            confirmButtonColor: "green",
                            cancelButtonColor: "darkred",
                            cancelButtonText: "No",
                            showLoaderOnConfirm: true,
                            icon: "question"
                        }).then((res) => {

                            if (res.isConfirmed) {
                                setLoading(true);
                                setIsSubmit(true)
                                let data = Crypter.encrypt(JSON.stringify(DemandMont));

                                let config = {
                                    method: 'post',
                                    maxBodyLength: Infinity,
                                    url: Data.ApiUrl.CreateMontantBloquer,
                                    headers: {
                                        'CypherMontantBloquer': data,
                                        'Authorization': authHeader(),
                                        'Content-Type': 'application/json'
                                    },
                                    data: data
                                };

                                axios.request(config)
                                    .then((response) => {
                                        setLoading(false);

                                        if (response.data) {

                                            const res = JSON.parse(Crypter.decrypt(response.data));

                                            if (res.StatutCode == 200) {
                                                let code = res.Result

                                                if (code == 'attente') {
                                                    SweetAlert.fire({ title: "Warning", text: 'Bien vouloir Valider ou Rejeter celui en attente de validation sur le compte', icon: "warning" })
                                                } else if (code == 'Distant') {
                                                    SweetAlert.fire({ title: "Warning", text: 'Operation Impossible : le Compte appartient a une autre agence', icon: "warning" })
                                                } else if (code == 'Erreur Journée') {
                                                    SweetAlert.fire({ title: "Warning", text: 'Operation Impossible : la Journée comptable n est pas ouverte', icon: "warning" })
                                                } else {
                                                    HandleEnreg();
                                                    form.resetFields()
                                                    localStorage.clear()
                                                    setIsSubmit(false)
                                                    SweetAlert.fire({ title: ' ', text: "Blocage effectué avec susccès: reference " + code, icon: "success" })
                                                }
                                            }
                                            else {
                                                SweetAlert.fire({ title: "Warning", text: res.Message, icon: "warning" })
                                            }
                                        }
                                    })
                                    .catch((error) => {
                                        setLoading(false);
                                        console.log(error)
                                        SweetAlert.fire({ title: "Error Front", text: error, icon: "error" })
                                    });
                            }
                        })
                    }
                }
            }
        }

        if (sbmit == "modif") {

            DemandMont.DATEFM = formatDate(DemandMont.DATEFM);
            DemandMont.DATCRE = formatDate(Perss.datjour);
            DemandMont.DATVAL = formatDate(Perss.datjour);


            if (form.getFieldValue("DATEFM") <= ReformatDate(Perss.datjour)) {
                SweetAlert.fire({ text: "Opération impossible :La date fin bloquage doit être supérieur à la date système ", icon: "warning" })
            } else {
                // verifier la difference entre le disponible et le montant bloquer
                if ((form.getFieldValue("MONTPR")) > (form.getFieldValue("DISPON"))) {
                    SweetAlert.fire({ text: "Opération impossible: Montant Bloquage superieure au solde disponible ", icon: "warning" })
                } else {

                    if ((form.getFieldValue("MONTPR")) < 0) {
                        SweetAlert.fire({ text: "Opération impossible: Le montant a bloqué doit être supérieur 0", icon: "warning" })
                    } else {
                        DemandMont.utival = Perss.coduti;
                        SweetAlert.fire({
                            title: "Mise à jour du Gel",
                            text: "Voulez-vous modifier la Gel de :" + values.lib_NUMCPT + " ?",
                            showCancelButton: true,
                            color: "green",
                            confirmButtonText: "Yes",
                            confirmButtonColor: "green",
                            cancelButtonColor: "darkred",
                            cancelButtonText: "No",
                            showLoaderOnConfirm: true,
                            icon: "question"
                        }).then((res) => {

                            if (res.isConfirmed) {
                                setLoading(true);
                                setIsSubmit(true)
                                let data = Crypter.encrypt(JSON.stringify(DemandMont));

                                let config = {
                                    method: 'put',
                                    maxBodyLength: Infinity,
                                    url: Data.ApiUrl.UpdateMontantBloquer,
                                    headers: {
                                        'CypherMontantBloquer': data,
                                        'Authorization': authHeader(),
                                        'Content-Type': 'application/json'
                                    },
                                    data: data
                                };

                                axios.request(config)
                                    .then((response) => {
                                        setLoading(false);

                                        if (response.data) {

                                            const res = JSON.parse(Crypter.decrypt(response.data));

                                            if (res.StatutCode == 200) {

                                                if (res.Message == 'IMPOSSIBLE') {
                                                    form.resetFields()
                                                    HandleEnreg()
                                                    SweetAlert.fire({ title: "Warning", text: "Impossible de Modifier un Monatnt qui à traverser l'étape de validation", icon: "warning" })

                                                } else {
                                                    let code = res.Result
                                                    form.resetFields()
                                                    localStorage.clear()
                                                    setIsSubmit(false)
                                                    HandleEnreg()
                                                    SweetAlert.fire({ title: '', text: "Mise à jour Effectué. Référence : " + res.Message, icon: "success" })

                                                }
                                            }
                                            else {
                                                SweetAlert.fire({ title: "Warning", text: res.Message, icon: "warning" })
                                            }

                                        }
                                    })
                                    .catch((error) => {
                                        setLoading(false);
                                        console.log(error)
                                        SweetAlert.fire({ title: "Error Front", text: error, icon: "error" })
                                    });
                            }
                        })
                    }
                }
            }
        }
    };

    // control du forms 
    const onFinishFailed = (errorInfo: any) => {
        setLoading(true);
        setLoading(false);
    };

    const verifSubmit = () => {
        if (!isSubmit) {
            SweetAlert.fire({ title: "Attention", text: "Veillez remplir tous les champs", icon: "warning" })
        }
    };

    //********************** Function Pour Afficher les Commissions à Afficher **************************/
    function change(e: any, indexe: number) {
        let value = e.target.value as number
        var t = 0
        if (value + "" == "") {
            form.setFieldValue("MONTAN" + indexe, 0)
        } else {
            form.setFieldValue("MONTAN" + indexe, value)
        }
        for (let i = 1; i <= commissions.length; i++) {
            var tmp = parseInt(form.getFieldValue("MONTAN" + i) + "") ? parseInt(form.getFieldValue("MONTAN" + i) + "") : 0
            t = t + tmp
            //console.log(t)
        }
        //alert(t)
        form.setFieldValue("cssionApliq", t)
    }

    //***************************************************************************************************/
    //********************** Tableau pour la liste des Commissions à Afficher ***************************/
    const commissions = [
        {
            indexe: 1,
            code: "943",
            label: "CION N1/ MONTANT BLOQUE/ COMPTE"
        },
        {
            indexe: 2,
            code: "944",
            label: "CION N2/ MONTANT BLOQUE/ COMPTE"
        },
        {
            indexe: 3,
            code: "945",
            label: "CION N3/ MONTANT BLOQUE/ COMPTE"
        },
        // {
        //     indexe: 3,
        //     code: "948",
        //     label: "CION N°3/MISE EN PLACE PRET"
        // },
        // {
        //     indexe: 4,
        //     code: "949",
        //     label: "CION N°4/MISE EN PLACE PRET"
        // }
    ]

    //***************************************************************************************************/
    //********************** Usestate Pour La gestion des états des Montants Commissions ****************/
    const [checked1, setChecked1] = React.useState(true);
    const [checked2, setChecked2] = React.useState(true);
    const [checked3, setChecked3] = React.useState(true);
    const [checked4, setChecked4] = React.useState(true);

    const [loadMont1, setLoadMont1] = React.useState(false);
    const [loadMont2, setLoadMont2] = React.useState(false);
    const [loadMont3, setLoadMont3] = React.useState(false);
    const [loadMont4, setLoadMont4] = React.useState(false);

    const tabCheck = [checked1, checked2, checked3, checked4]

    //***************************************************************************************************/
    //********************** Function Pour la gestion des Montant des commissions ***********************/
    const onChange = (cssion: any) => {

        let montant = -1;

        if (montant) {

            let indexe = cssion.indexe
            let mont = 0;
            switch (indexe) {
                case 1:
                    setChecked1(!checked1)
                    setLoadMont1(true);
                    break;
                case 2:
                    setChecked2(!checked2)
                    setLoadMont2(true);
                    break;
                case 3:
                    setChecked3(!checked3)
                    setLoadMont3(true);
                    break;
                case 4:
                    setChecked4(!checked4)
                    setLoadMont4(true);
                    break;
                default:
                    break;
            }

            const datat: DataType[] = [];
            var datas = { commission: null }
            //var data = { CodeAgence: searchMontantCsion?.CodeAgence, Table: searchMontantCsion?.Table, Colonne1: searchMontantCsion?.Colonne1, Colonne2: searchMontantCsion?.Colonne2, Colagence: searchMontantCsion?.Colagence, Init: cssion.code, choix: searchMontantCsion?.Choix }
            var com = { "CodOpe": cssion.code, Montant: montant, "CodAge": Perss.codage }

            var config = {
                method: 'get',
                maxBodyLength: Infinity,
                url: Data.ApiUrl.GetCommission,
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': authHeader(),
                    'CypherCommission': Crypter.encrypt(JSON.stringify(com))
                }
            };
            axios(config)
                .then((response) => {
                    //alert('ok')
                    if (response.data) {
                        const res = JSON.parse(Crypter.decrypt(response.data)).Value;

                        if (res.StatutCode == 200) {
                            datas = res.Result.Table[0];

                            switch (indexe) {
                                case 1:
                                    if (!checked1) {
                                        mont = form.getFieldValue('MNTANT' + indexe) ? form.getFieldValue('MNTANT' + indexe) : 0
                                        form.setFieldValue('MNTANT' + indexe, "0")
                                    } else {
                                        form.setFieldValue("MNTANT" + indexe, datas.commission)
                                    }
                                    setChecked1(!checked1)
                                    break;
                                case 2:
                                    if (!checked2) {
                                        mont = form.getFieldValue('MNTANT' + indexe) ? form.getFieldValue('MNTANT' + indexe) : 0
                                        form.setFieldValue('MNTANT' + indexe, "0")
                                    } else {
                                        form.setFieldValue("MNTANT" + indexe, datas.commission)
                                    }
                                    setChecked2(!checked2)
                                    break;
                                case 3:
                                    if (!checked3) {
                                        mont = form.getFieldValue('MNTANT' + indexe) ? form.getFieldValue('MNTANT' + indexe) : 0
                                        form.setFieldValue('MNTANT' + indexe, "0")
                                    } else {
                                        form.setFieldValue("MNTANT" + indexe, datas.commission)
                                    }
                                    setChecked3(!checked3)
                                    break;
                                case 4:
                                    if (!checked4) {
                                        mont = form.getFieldValue('MNTANT' + indexe) ? form.getFieldValue('MNTANT' + indexe) : 0
                                        form.setFieldValue('MNTANT' + indexe, "0")
                                    } else {
                                        form.setFieldValue("MNTANT" + indexe, datas.commission)
                                    }
                                    setChecked4(!checked4)
                                    break;

                                default:
                                    break;
                            }
                            var MNTANTt = parseInt(form.getFieldValue('MNTANT' + indexe) + "") ? parseInt(form.getFieldValue('MNTANT' + indexe) + "") : 0
                            var total = parseInt(form.getFieldValue("cssionApliq") + "") ? parseInt(form.getFieldValue("cssionApliq") + "") : 0


                            switch (indexe) {
                                case 1:
                                    if (checked1) {
                                        total = total + montant
                                    } else {
                                        total = total - mont
                                    }
                                    break;
                                case 2:
                                    if (checked2) {
                                        total = total + montant
                                    } else {
                                        total = total - mont
                                    }
                                    break;
                                case 3:
                                    if (checked3) {
                                        total = total + montant
                                    } else {
                                        total = total - mont
                                    }
                                    break;
                                case 4:
                                    if (checked4) {
                                        total = total + montant
                                    } else {
                                        total = total - mont
                                    }
                                    break;
                                default:
                                    break;
                            }



                            form.setFieldValue("cssionApliq", total)
                            //SetData([{Code: datas.CODOPE, Libelle : datas.MONFIX, key: 0}])
                        }
                    }
                    //setLoadMont1(false);

                }).catch((error) => {
                    //console.log(error)
                    setChecked1(true);
                    setChecked2(true);
                    setChecked3(true);
                    setChecked4(true);


                    SweetAlert.fire({ title: "Error", text: error, icon: "error" })
                }).finally(() => {
                    switch (indexe) {
                        case 1:
                            setLoadMont1(false);
                            break;
                        case 2:
                            setLoadMont2(false);
                            break;
                        case 3:
                            setLoadMont3(false);
                            break;
                        case 4:
                            setLoadMont4(false);
                            break;
                        // case 5:
                        //   setLoadMont5(false);
                        //   break;

                        default:
                            break;
                    }
                })
        }
        else {
            SweetAlert.fire({ title: "Veillez saisir le montant de la demande de prêt", icon: "warning" })
        }
    }

    /*********************** */
    interface SelectData {
        value: string,
        label: string,
    }

    const [loadCompte, setLoadCompte] = useState(false)
    const [numcpt, setNumcpt] = useState("")
    const [CompetClients, SetCompetClients] = useState<SelectData[]>([])

    const handleChangeGompte = (value: string) => {
        setNumcpt(value);
        form.setFieldValue("NUMCPT", value)
        //alert(props.form.getFieldValue("NUMCPT"))
    };

    function loadClientCompte() {
        setNumcpt("")
        setLoadCompte(true)
        SetCompetClients([])

        // setCompteEpargne([])
        // setCompteOrdinaire([])
        // setNumcpt("")
        let numcli = form.getFieldValue("NUMCLI")
        //alert(numcli)
        if (numcli != "") {
            let searchClientComptes: ParamsPicklist = { CodeAgence: '', Table: "COMPTES", Colonne1: "NUMCLI", Colonne2: "", Init: numcli, Colagence: '101', Choix: 33 }

            var config = {
                method: 'get',
                maxBodyLength: Infinity,
                url: Data.ApiUrl.AnySearch,
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': authHeader(),
                    'CypherSearch': Crypter.encrypt(JSON.stringify(searchClientComptes))
                }
            };
            axios(config)
                .then((response) => {
                    //alert('ok')
                    if (response.data) {
                        const res = JSON.parse(Crypter.decrypt(response.data)).Value;


                        //alert(JSON.stringify(res))
                        if (res.StatutCode == 200) {
                            let datas = res.Result.Table;
                            //alert(JSON.stringify(datas))

                            //alert(datas.length)
                            if (datas.length === 0) {
                                SweetAlert.fire({ title: "This client don't have accounts", icon: "warning" })
                            }
                            else {
                                const datat: SelectData[] = [];

                                datas.map((data: COMPTES) => {
                                    //console.log(JSON.stringify(data))
                                    //alert(data.IDPLAN.substring(0, 3))

                                    datat.push({
                                        value: data.NUMCPT,
                                        label: data.NUMCPT, // + " - " + data.NOMCPT,
                                    });
                                    SetCompetClients(datat);

                                    //alert(JSON.stringify(datat))
                                })
                                //alert(JSON.stringify(datat))
                            }
                        } else {
                            SweetAlert.fire({ title: "Comptes", text: res.Message, icon: "warning" })
                        }
                    }
                    setLoadCompte(false);
                }).catch(() => {
                    setLoadCompte(false);
                })

        }
    }

    // useEffect(() => {
    //     try {
    //         if (Crypter.decrypt(localStorage.getItem("numcpt") + "") != "" && Crypter.decrypt(localStorage.getItem("numcpt") + "") != undefined) {
    //             loadClientCompte()
    //             setNumcpt(Crypter.decrypt(localStorage.getItem("numcpt") + "") as string)
    //             localStorage.setItem("numcpt", "")
    //         }
    //     } catch (error) { }
    // })

    // setTimeout(() => {
    //     try {
    //         let reset = localStorage.getItem(Data.LocalVariable.reset)
    //         if (reset == "1") {
    //             SetCompetClients([])
    //             setNumcpt("")
    //         }
    //         localStorage.removeItem(Data.LocalVariable.reset)
    //     }
    //     catch (error) { }

    //     try {
    //         let isOkay = localStorage.getItem("load_compte")
    //         if (isOkay == "1") {
    //             loadClientCompte()
    //         }
    //         localStorage.removeItem("load_compte")
    //     } catch (error) { }
    // }, 0.1);



    return (
        <div className='tab'>
            <Typography align='center' className='formTitle'><b> Marquage d'une Provision sur un Compte : {window.location.pathname.toUpperCase()}</b></Typography>
            <Spin spinning={loading} size='large' style={{ color: 'green' }} >
                <Form disabled={!ajoutActve} autoComplete="off" labelAlign='left' form={form} name="dynamic_form_complex" onFinish={onFinish} onFinishFailed={onFinishFailed} style={{ minWidth: 'auto', maxWidth: 'auto' }}>
                    <div className='bG'>
                        <legend><Typography color={"darkgreen"}>Actions</Typography></legend>
                        <Form.Item shouldUpdate className='bouttong'>
                            <Space direction="vertical" style={{ width: '100%' }}>
                                <Button size='large' className='bt_add' disabled={Consult} onClick={() => { HandleConsult(); consult() }} type="ghost" block>
                                    Consulter
                                </Button>
                                <Button size='large' className='bt_add' disabled={Ajout} onClick={() => { HandleAjout(); setSbmit("add") }} type="ghost" block  >
                                    Ajouter
                                </Button>
                                <Button size='large' className='bt_add' disabled={Modif} onClick={() => { HandleModif(); setSbmit("modif") }} type="ghost" block  >
                                    Modifier
                                </Button>
                                <Button size='large' className='bt_add' disabled={Enreg} onClick={() => { }} type="ghost" htmlType="submit" block>
                                    Enregistrer
                                </Button>
                                <Button size='large' className='bt_add' disabled={Supp} onClick={() => { HandleSupp(); setSbmit("supp") }} type="ghost" block>
                                    Supprimer
                                </Button>
                                <Button size='large' className='bt_add' disabled={Actualise} onClick={() => { HandleReset() }} type="ghost" block  >
                                    Actualiser
                                </Button>
                                <Button size='large' disabled={Annul} onClick={() => { HandleAnnul() }} className='bt_add' type="ghost" htmlType="reset" block>
                                    Annuler
                                </Button>
                            </Space>
                        </Form.Item>
                    </div>
                    <div className='clientP'>
                        <div>
                            <div >
                                <Tabs size='large' type="card" defaultActiveKey="1" items={items} />
                            </div>

                            <div className='tabItem' >

                                <div style={{ display: 'block flow' }}  >
                                    <Box fontStyle="inherit" className='border' width={"85%"} position={"absolute"}  >
                                        <Box fontStyle="inherit" className='border-left '>
                                            <legend> Mise en place d'un Montant Bloqué </legend>
                                            <fieldset className="bordure1" style={{ marginTop: -10 }}>
                                                <Box style={{ display: 'flex' }}>
                                                    <Box>
                                                        <Box style={{ marginTop: -5 }}>
                                                            <SearInputG notRequired dissabledCode={LibellCode} width={4} Titre="Recherche" label="Réference" name="REFMARQ" Taille1={'100%'} Taille2={0} form={form} Parametre={searchMontanLock} />
                                                        </Box>
                                                        <Box style={{ marginTop: -10 }}>
                                                            <SearchModal width={4} Titre="Recherche" label="Id Client" name="NUMCLI" ExecuteafterSelect1={Getselectcli} ExecuteafterSelect2={loadClientCompte} Taille1={150} Taille2={400} form={form} Parametre={searchCLient} />
                                                        </Box>
                                                        <Box style={{ marginTop: -10 }}>
                                                            <SearchModal  Titre="Recherche" label="N° de compte" name="NUMCPT" ExecuteafterSelect2={GetCompte} Taille1={250} Taille2={300} form={form} Parametre={searchCompte} />
                                                        </Box>
                                                    </Box>
                                                    <Box >
                                                        <Box style={{ marginTop: -5, width: '100%' }}>
                                                            <InputForm label="Date Fin Blocage" width={11} name="DATEFM" type="date" />
                                                        </Box>
                                                        <Box style={{ marginTop: -10, width: '100%' }}>
                                                            <InputForm width={11} label="Mntant Bloquage" type="number" name="MONTPR" />
                                                        </Box>
                                                        <Box style={{ marginTop: -10, width: '100%' }}>
                                                            <InputForm disabled={true} width={11} label="Mntant Disponible" type="number" name="DISPON" />
                                                        </Box>
                                                    </Box>
                                                </Box>
                                            </fieldset>
                                            <fieldset className="bordure1" style={{ marginTop: 0 }}>
                                                <Box style={{ marginTop: -5, width: '100%' }}>
                                                    <InputForm width={3} label="Motif Bloquage" type="texte" name="MOTIFM" />
                                                </Box>
                                            </fieldset>
                                            <fieldset className="bordure1" style={{ marginTop: 0 }}>
                                                <Box style={{ paddingLeft: 10, marginTop: -5 }}>
                                                    <Box style={{ display: 'flex' }}>
                                                        <Box fontStyle="inherit" >
                                                            {commissions.map((cssion, indexe) => (
                                                                <Box marginTop={1} >
                                                                    <Checkbox style={{ marginTop: -5 }} checked={!tabCheck[indexe]} onChange={() => { onChange(cssion) }}>
                                                                        <SearInputM width={6} defaultCode={cssion.code} defaultLibelle={cssion.label} form={form} Titre={'Recherche Type Commission ' + (indexe + 1)} label={'Commission.. ' + (indexe + 1)} name={'CODOP' + (indexe + 1)} Parametre={searchCsion} />
                                                                    </Checkbox>
                                                                </Box>
                                                            ))}
                                                        </Box>
                                                        <Box>
                                                            <Box style={{ marginTop: 5 }}>
                                                                <InputForm min={0} defaultValue='0' disabled={true} onChange={(e) => { change(e, 1) }} width={9} label={'Montant 1'} name={'MNTANT1'} type='number' error='mobile' />
                                                            </Box>
                                                            <Box style={{ marginTop: -7 }}>
                                                                <InputForm min={0} defaultValue='0' disabled={true} onChange={(e) => { change(e, 2) }} width={9} label={'Montant 2'} name={'MNTANT2'} type='number' error='mobile' />
                                                            </Box>
                                                            <Box style={{ marginTop: -7 }}>
                                                                <InputForm min={0} defaultValue='0' disabled={true} onChange={(e) => { change(e, 3) }} width={9} label={'Montant 3'} name={'MNTANT3'} type='number' error='mobile' />
                                                            </Box>
                                                        </Box>
                                                    </Box>
                                                </Box>
                                            </fieldset>
                                        </Box>
                                    </Box>

                                </div>
                            </div>
                        </div>
                    </div>
                </Form>
            </Spin>
        </div>
    );


}

export default AddBlocage;